import { MAP_STOP_LABELS } from "../../../../config/global.configuration";
import {
    computeItineraryStepDelaySec,
    formatIsoToHHMM,
} from "../../../../tools/MapItineraryTools";
import type { ItineraryLegStepDTO } from "../../../../types/dtos/api/itinerary/itinerary.dto";
import { resolveStopCorrespondenceRoutes, type StopLabelData } from "../stopLabels";

/**
 * Builds a {@link StopLabelData} from an itinerary step, respecting global toggles.
 *
 * @param step Itinerary leg step.
 * @param name Normalised stop name.
 * @returns Presentation-ready stop label data.
 */
export function buildItineraryStopLabelData(
    step: ItineraryLegStepDTO,
    name: string,
): StopLabelData {
    const arrivalTime = MAP_STOP_LABELS.itinerary.showArrivalTime
        ? formatIsoToHHMM( step.time )
        : null;

    const delaySec = computeItineraryStepDelaySec( step.time, step.scheduledTime );

    const correspondenceRoutes = MAP_STOP_LABELS.itinerary.showCorrespondences
        ? resolveStopCorrespondenceRoutes( step.stop?.id ?? "", { "parentStation": step.stop?.parent ?? null } )
        : [];

    return {
        name,
        arrivalTime,
        delaySec,
        "hasRealtimeDelay":   step.time !== undefined && step.scheduledTime !== undefined,
        "applyDelayColoring": MAP_STOP_LABELS.itinerary.showDelayStatus,
        correspondenceRoutes,
    };
}
